import {
  firmDailyNavSettingsUrl,
  firmScalarAiSettingsUrl,
  firmScimConfigurationUrl,
  firmSettingsUrl,
  firmSingleSignOnUrl,
} from 'common/config/urls';
import {
  DAILY_NAV_SETTINGS_PAGE_TITLE,
  DAILY_NAV_SETTINGS_TAB,
  FIRM_SETTINGS_SLUG,
  SCALAR_AI_SETTINGS_PAGE_TITLE,
  SCALAR_AI_SETTINGS_TAB,
  SCIM_CONFIGURATION_PAGE_TITLE,
  SCIM_CONFIGURATION_TAB,
  SINGLE_SIGN_ON_PAGE_TITLE,
  SINGLE_SIGN_ON_TAB,
} from 'common/constants/firms';
import type { SecondaryNavigationLinkItem } from 'context/FirmBaseLayoutContext';

// SCAL-9352: single source for the firm-settings tab strip. The four settings
// pages used to re-declare this list independently; add new tabs HERE only.
export const buildFirmSettingsNavigationItems = (
  firmSlug: string,
  { dailyNavEnabled }: { dailyNavEnabled: boolean }
): SecondaryNavigationLinkItem[] => [
  { label: 'Firm Profile', value: FIRM_SETTINGS_SLUG, to: firmSettingsUrl(firmSlug) },
  { label: SINGLE_SIGN_ON_PAGE_TITLE, value: SINGLE_SIGN_ON_TAB, to: firmSingleSignOnUrl(firmSlug) },
  { label: SCIM_CONFIGURATION_PAGE_TITLE, value: SCIM_CONFIGURATION_TAB, to: firmScimConfigurationUrl(firmSlug) },
  ...(dailyNavEnabled
    ? [{ label: DAILY_NAV_SETTINGS_PAGE_TITLE, value: DAILY_NAV_SETTINGS_TAB, to: firmDailyNavSettingsUrl(firmSlug) }]
    : []),
  { label: SCALAR_AI_SETTINGS_PAGE_TITLE, value: SCALAR_AI_SETTINGS_TAB, to: firmScalarAiSettingsUrl(firmSlug) },
];
